<template>
    <div class="app app-container-soluquim" ref="mainContainerRef"
        :class="{ 'inicio-gradient': $route.path === '/inicio' }">
        <AppHeader fixed v-if="!fullscreenActive">
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="/inicio">
                <img class="navbar-brand-full" src="img/brand/logo_soluquim.png" width="100" height="25"
                    alt="Soluquim" />
                <img class="navbar-brand-minimized mb-1" src="img/brand/icono-solo.png" width="150" height="50"
                    alt="Soluquim" />
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" ref="sidebarToggler" />
            <b-navbar-nav class="d-md-down ml-auto">

                <el-select v-if="validarRol('contratista')" v-model="value" placeholder="Seleccionar empresa"
                    size="small">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <b-nav-item class="d-md-down">
                    <DefaultHeaderDropdown />
                </b-nav-item>

                <b-nav-item class="d-md-down mr-2">
                    <div class="company-content-navbar">
                        <b-button @click="() => onHandleGoToMyCompany()" tabindex="0" variant="light">
                            <b-img :src="selectedImagenCurrentCompany.imagen" fluid alt="Logo empresa"></b-img>
                        </b-button>
                    </div>
                </b-nav-item>

                <b-nav-item class="d-md-down">
                    <div class="user-content-navbar">
                        <b-button id="popover-user-content-navbar" href="#" tabindex="0" variant="light" @click="() => {(isVisibleTranslateContent = false), togglePopoverUserMenu}">
                            <b-avatar
                                size="2rem"
                                :badge="notifications.length > 0 ? `${notifications.length}` : null"
                                variant="primary"
                                badge-variant="light"
                                badge-left
                                badge-offset="-1.5em"
                            >{{ getUser.username }}</b-avatar>
                        </b-button>
                        <b-popover target="popover-user-content-navbar" variant="light" triggers="focus" custom-class="custom-class-user-content-navbar">
                            <div class="p-2">
                                <div class="custom-class-user-content-navbar-content d-flex justify-content-start align-items-center">
                                    <div class="custom-class-user-content-navbar--header-img">
                                        <b-avatar size="2rem" variant="primary">{{ getUser.username }}</b-avatar>
                                    </div>
                                    <div class="ml-2">
                                        <strong>{{ getUser.name }}</strong>
                                        <br />
                                        <p class="text-muted m-0">{{ getUser.email }}</p>                                                  
                                    </div>
                                </div>
                                <h5 class="ml-roles text-normal" v-for="role of getUser.roles" :key="role"><b-badge variant="primary">{{ role }}</b-badge></h5>                              
                                <div class="custom-class-user-content-navbar-separator"></div>
                                <div>

                                    <!-- Notificaciones -->
                                    <div class="mt-2 d-flex justify-content-between align-items-center cursor-pointer custom-class-user-content-navbar-items" @click="notify = true">
                                        <div>
                                            <i class="nav-icon icon-bell mr-2 text-primary" />
                                            <b-link href="#" class="text-dark">Notificaciones</b-link>
                                        </div>
                                        <h5 class="m-0"><b-badge variant="danger">{{ notifications.length }}</b-badge></h5>
                                    </div>

                                    <!-- Traducir sistema -->
                                    <div class="w-100" v-b-modal.translate-modal>

                                        <div class="d-flex align-items-center justify-content-between cursor-pointer custom-class-user-content-navbar-items" 
                                            :class="isVisibleTranslateContent ? null : 'collapsed'"
                                            :aria-expanded="isVisibleTranslateContent ? 'true' : 'false'"
                                            aria-controls="collapse-available-translate"
                                            @click="isVisibleTranslateContent = !isVisibleTranslateContent">
                                            <div>
                                                <i class="nav-icon fa fa-language mr-2 text-primary"></i>
                                                <span style="font-size: 12px;" class="text-dark">Traducir sistema</span>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-end">
                                                <h6 class="m-0 mr-2"><b-badge variant="light">3 <small>IDIOMAS</small></b-badge></h6>
                                                <i :class="isVisibleTranslateContent ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" />
                                            </div>
                                        </div>

                                        <b-collapse id="collapse-available-translate" v-model="isVisibleTranslateContent" class="mt-2 p-0 m-0">
                                            <b-card no-body class=" shadow-sm border-none border-0">
                                                <TranslateModal ref="translateModalRef" />
                                            </b-card>
                                        </b-collapse>

                                    </div>       
                                    
                                    <!-- Administración -->
                                    <div 
                                        v-if="validarRol('superadmin')" 
                                        class="d-flex align-items-center cursor-pointer custom-class-user-content-navbar-items" 
                                        @click="() => onHandleGoToSettings()"
                                    >
                                        <i class="fa fa-cogs mr-2 text-primary"></i>
                                        <b-link href="#" class="text-dark">Administración</b-link>
                                    </div>
                                </div>
                                <div class="custom-class-user-content-navbar-separator"></div>
                                <div class="mt-3 d-flex justify-content-between align-items-bottom">
                                    <div></div>
                                    <b-link href="#" @click="_logout" class="text-danger cursor-pointer">
                                        <i class="cui-account-logout icons mr-1" />
                                        CERRAR SESIÓN
                                    </b-link>
                                </div>
                            </div>
                        </b-popover>
                    </div>
                </b-nav-item>

            </b-navbar-nav>
        </AppHeader>

        <!-- Modal detalles notificaciones -->
        <b-modal v-model="notify" ok-only class="float-left" scrollable title="Notificaciones">
            <p class="my-4" v-for="notification in notifications" :key="notification.id">
                <b-card :title="notification.data['title']">
                    <b-card-text>
                        {{ notification.data['description'] }}
                    </b-card-text>
                    <template #footer>
                        <small class="text-muted">Fecha: {{ notification.created_at }}</small> -
                        <b-button small @click="accionNotify(notification)" variant="primary">{{
                            notification.data['btn'] }}</b-button>
                    </template>
                </b-card>
            </p>
            <template v-if="notifications.length <= 0">
                <p>No tiene notificaciones.</p>
            </template>
        </b-modal>

        <div class="app-body">
            <div v-show="loading">
                <Loader></Loader>
            </div>
            <AppSidebar fixed>
                <b-overlay :show="overlayMenu" rounded="sm">
                    <div class="filter-search-container">
                        <!-- Buscador de ítems del menú -->
                        <div class="filter-search-form">
                            <input  
                                v-model="filterSearch" 
                                @keyup="onHandleSearch"
                                placeholder="Buscar módulos o sub módulos..." 
                                type="text"
                                class="filter-search-form-input" 
                                autocomplete="off"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false" />
                            <i class="fa fa-search filter-search-form-icon"></i>
                            <i @click="onHandleCancelSearch" title="Cancelar, y restablecer datos."
                                class="fa fa-close filter-search-form-icon-cancel"></i>
                        </div>

                        <!-- Resultados de búsqueda [ítems del menú] -->
                        <div v-if="navItems.length <= 0 && !overlayMenu" class="p-2 mt-4 text-center">

                            <i class="fa fa-search mr-2 text-dark"></i>
                            <small class="d-block text-dark">No se encontrar resultados.</small>
                            <b-button class="mt-1 text-dark px-3" pill variant="outline-info" size="sm"
                                @click="onHandleCancelSearch">
                                <i class="fa fa-refresh mr-1 text-dark"></i>
                                Actualizar menú
                            </b-button>

                            <b-alert show variant="warning" class="mt-4">
                                <small>
                                    <i class="fa fa-info-circle mr-1 text-dark"></i>
                                    Debes ingresar el nombre del módulo o sub módulo que deseas consultar.
                                </small>
                            </b-alert>

                            <!-- Ejemplo de ítems -->
                            <b-list-group class="p-0 mt-4">
                                <div class="mb-1 p-2 bg-info d-flex align-items-center">
                                    <i class="fa fa-list mr-2"></i>
                                    <small>Sugerencias de búsqueda</small>
                                </div>
                                <b-list-group-item v-for="(item, index) in getMenuExample" :key="index"
                                    class="p-2 d-flex justify-content-start gap-2"
                                    @click="onHandleSearchWithSuggested(item.name)" button>
                                    <i class="nav-icon mr-2 text-dark" style="width: 20px;" :class="item.icon"></i>
                                    <small class="text-dark">{{ item.name }}</small>
                                </b-list-group-item>
                            </b-list-group>

                        </div>
                    </div>
                </b-overlay>

                <SidebarHeader />
                <SidebarForm />
                <SidebarNav v-if="!overlayMenu" ref="sidebarNavRef" :navItems="navItems"></SidebarNav>

                <div class="p-2 d-flex justify-content-center mb-4"
                    v-if="(filterSearch && filterSearch.length > 0) && navItems.length > 0">
                    <div class="text-center">
                        <small class="d-block text-dark">Restablecer ítems del menú.</small>
                        <b-button class="mt-1 text-dark px-3" pill variant="info" size="sm"
                            @click="onHandleCancelSearch">
                            <i class="fa fa-refresh mr-1 text-dark"></i>
                            ACTUALIZAR MENÚ
                        </b-button>
                    </div>
                </div>

                <h6 v-if="version" class="text-version text-right">v.{{ version }}</h6>
                <SidebarFooter />
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main" ref="mainContainerRef">
                <modal-banner />
                <div style="-webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;"
                    class="container-fluid main-content" :class="{
                        'main-content-cp': $route.path === '/panel-de-control',
                        'inicio-gradient-2': $route.path === '/inicio'
                    }">
                    <router-view />
                </div>
            </main>
            <AppAside fixed>
                <DefaultAside />
            </AppAside>
        </div>
        <TheFooter>
            <!--footer-->
            <div class="ml-auto">
                <span class="mr-1">Desarrollado por</span>
                <a href="https://web.mejoraysoluciones.com/">Mejora & Soluciones </a>
            </div>
        </TheFooter>

    </div>
</template>

<script>
import nav from '@/_nav';
import { mapState, mapActions, mapMutations } from 'vuex';
import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb,
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdown from './DefaultHeaderDropdown';
import { getAcls, validarPermisoComponente } from '../plugins/acl';
import Loader from './loader';
import modalBanner from '../views/banners/modal_banner';
import Pusher from 'pusher-js';
import TranslateModal from "./TranslateModal";
import moment from "moment";

export default {
    name: 'DefaultContainer',
    components: {
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdown,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
        Loader,
        modalBanner,
        TranslateModal
    },
    data() {
        return {
            acls: '',
            navItems: [],
            navItemsTemporary: [],
            refresh: false,
            destroyed: false,
            notify: false,
            version: '',

            inactiveTime: 0,
            activityTimer: null,
            activityTimeout: process.env.VUE_APP_TIME_INACTIVE,
            sendInfo: false,
            from: moment().format('YYYY-MM-DD HH:mm:ss'),
            to: null,
            statusList: [200, 201],

            overlayMenu: false,
            filterSearch: null,
            temporaryImagenCompany: "img/brand/logo_soluquim.png",
            isVisibleTranslateContent: false,
            validatePermissionComponent:  validarPermisoComponente,
            popoverVisibleUserMenu: false
        };
    },
    async mounted() {

        this.addRefEventToItemMenu();

        this.suscripcionPusher();
        this.validarPermisoNotificaciones();
        this.version = localStorage.getItem('version');

        window.addEventListener("mousemove", this.resetTimer);
        window.addEventListener("keypress", this.resetTimer);
        window.addEventListener("click", this.resetTimer);
        window.addEventListener("scroll", this.resetTimer);
        this.startTimer();

        await this.getImagen({
            companyId: localStorage.getItem('my_company'),
            module: 'COMPANY'
        });
        this.showLicenceAlert();
    },

    beforeMount() {
        this.menu();
        this.navItemsTemporary = this.validMenuWithPermissions();

        if (!['http://localhost:8080', 'http://127.0.0.1:8080', 'http://soluquim.test:8080'].includes(document.location.origin)) {

            window.onbeforeunload = () => {
                if (this.refresh === false && localStorage.getItem('token')) {
                    return true;
                }
            };

            window.onunload = () => {

                if (this.refresh === false && localStorage.getItem('token')) {
                    var formData = new FormData();
                    formData.append('token', localStorage.getItem('tokenn'));
                    formData.append('uuid', this.acls.uuid);
                    formData.append('from', this.from);
                    if (!this.to) {
                        this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                    }
                    formData.append('to', this.to);
                    navigator.sendBeacon(
                        process.env.VUE_APP_API_URL + '/api/v1/auth/logout',
                        formData
                    );
                    localStorage.clear();
                }
            };

            window.addEventListener('keydown', (e) => {
                if (
                    e.key == 'F5' ||
                    (e.ctrlKey && e.key == 'F5') ||
                    (e.ctrlKey && e.key == 'r') ||
                    (e.ctrlKey && e.shiftKey && e.key == 'R')
                ) {
                    this.refresh = true;
                }
            });
        }
    },

    methods: {
        ...mapActions('autenticacion', ['logout', 'saveTimeActiveFromUserAuth','showLicenceAlert']),
        ...mapActions('dashboard', ['notificationMarkAsRead', 'notificationsUnread']),
        ...mapMutations('dashboard', ['setTabActive']),
        ...mapActions('empresa', ['getImagen', 'getUsuario']),

        togglePopoverUserMenu() {
            this.popoverVisibleUserMenu = !this.popoverVisibleUserMenu;
        },

        handleInputFilterSearch() {
            if (this.$refs.mainContainerRef) this.$refs.mainContainerRef.classList.add('sidebar-show');
            this.filterMenu(this.filterSearch, 200)
        },

        onHandleGoToMyCompany() {
            const companyId = localStorage.getItem('my_company')
            if (!companyId) return

            this.$router.push(`/my-company/${companyId}`)
        },

        onHandleGoToSettings() {
            this.popoverVisibleUserMenu = false

            if (this.$router.history.current.path == "/administracion") return 
            this.$router.push(`/administracion`)
        },

        menu() {
            this.navItems = this.validMenuWithPermissions();
            this.overlayMenu = false
        },

        validarPermiso(item) {
            let visible = false;

            if (!!item.permisos.length) {
                visible = !!this.acls.permisos.filter(permiso => item.permisos.includes(permiso)).length;

                if (!visible) {
                    visible = !!this.acls.roles.filter(permiso => item.permisos.includes(permiso)).length;
                }
            }

            return visible;
        },
        async _logout() {
            if (this.destroyed === false) {
                this.refresh = true;
                if (!this.to) {
                    this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                }
                await this.saveTimeActiveFromUserAuth({ from: this.from, to: this.to }).catch((err) => { })
                await this.logout();
                await this.$router.push('/login');
                this.destroyed = false;
            }
        },
        validarRol(rolABuscar) {
            return !!this.acls.roles.find((role) => role === rolABuscar);
        },
        suscripcionPusher() {
            const acls = getAcls();

            if (!acls || !acls.uuid) {
                return;
            }

            let nombre_canal = acls.uuid;

            Pusher.logToConsole = false;

            let pusher = new Pusher('5c41c1dc4bec329b2165', {
                cluster: 'us2'
            });

            let canal = pusher.subscribe(nombre_canal);
            canal.bind('notificaciones', async (data) => {

                if (Notification.permission !== 'granted') {
                    Notification.requestPermission();
                } else {
                    let notification = new Notification(data.mensaje.titulo,
                        {
                            icon: 'favicon.ico',
                            body: data.mensaje.texto,
                            requireInteraction: true
                        }
                    );

                    if (data.mensaje.url) {
                        notification.onclick = (event) => {
                            event.preventDefault();
                            window.open(process.env.VUE_APP_API_URL + data.mensaje.url, '_blank');
                        };
                    }

                    if (data.mensaje.visibleNotification) {
                        setTimeout(async () => {
                            await this.notificationsUnread()
                        }, 3000);

                    }

                    setTimeout(() => {
                        notification.close();
                    }, 10000);

                    this.$notify({
                        title: data.mensaje.titulo,
                        message: data.mensaje.texto,
                        type: data.mensaje.error ? 'error' : 'success',
                        url: data.mensaje.url,
                        duration: 8000
                    });
                }
            });
        },
        validarPermisoNotificaciones() {
            console.log('DOMContentLoaded');
            document.addEventListener('DOMContentLoaded', () => {

                console.log(Notification);

                if (!Notification) {
                    return;
                }

                if (Notification.permission !== 'granted') {
                    Notification.requestPermission();
                }
            });
        },
        async accionNotify(notification) {
            if (notification.data.table && notification.data.table == 'temporary_locations') {
                this.setTabActive(13)
            }
            await this.notificationMarkAsRead(notification.id)
            if (notification.data.url) {
                this.notify = false
                if (this.$route.path !== notification.data.url) await this.$router.push(notification.data.url);
            }
        },
        startTimer() {
            this.activityTimer = setInterval(async () => {
                this.inactiveTime += 1000;
                if (this.inactiveTime >= this.activityTimeout) {
                    this.to = moment().format('YYYY-MM-DD HH:mm:ss');
                    if (this.sendInfo === false) {
                        if (this.statusList.includes(this.statusResponse)) {
                            await this.saveTimeActiveFromUserAuth({ from: this.from, to: this.to });
                            this.sendInfo = true;
                        }
                    }
                } else {
                    if (this.sendInfo) {
                        this.from = moment().format('YYYY-MM-DD HH:mm:ss')
                        this.sendInfo = false;
                    }
                }
            }, 1000);
        },
        resetTimer() {
            this.inactiveTime = 0;
        },

        /**
           * Agregar o eliminar evento a los Links del menú.
           * @param action
           */
        addRefEventToItemMenu(action = true) {

            if (!(this.$refs.sidebarNavRef && '$el' in this.$refs.sidebarNavRef)) return

            // Buscar los elementos .nav-item con un hijo .nav-link
            const sidebarNavItems = this.$refs.sidebarNavRef.$el.querySelectorAll('.nav-item > .nav-link');

            // Agregar/Eliminar un evento click a cada uno
            sidebarNavItems.forEach((link) => {
                if (action) link.addEventListener('click', this.handleSidebarNavItemClick);
                else link.removeEventListener('click', this.handleSidebarNavItemClick)
            });

        },

        /**
        * Buscar items.
        *
        * @param param
        */
        filterMenu(param, timeToSearch = 0) {

            /* const results = this.filterByName(this.navItems, param);
            setTimeout(() => this.navItems = this.validMenuWithPermissions(results), timeToSearch) */
            const currentOrTemporaryItems = (this.navItems && this.navItems.length) > 0 ? this.navItems : this.navItemsTemporary
            const results = this.filterByName(currentOrTemporaryItems, param);
            setTimeout(() => {
                this.navItems = this.validMenuWithPermissions(results)
                this.overlayMenu = false
            }, timeToSearch)

        },

        /**
        * Evento buscar ítems del menú.
        */
        onHandleSearch(event) {

            const valueToSearch = event.target.value
            this.filterSearch = valueToSearch
            if (valueToSearch && valueToSearch.length <= 0) return false;

            this.overlayMenu = true

           if ((valueToSearch && valueToSearch.length <= 0) || !valueToSearch) {
                this.menu();
                this.overlayMenu = false
                return
            }

            if (event.key === "Backspace")  this.overlayMenu = false

            else this.filterMenu(valueToSearch, 800)

        },

        /**
        * Evento buscar ítems del menú a partir de un sugerencia.
        *
        * @param itemName
        */
        onHandleSearchWithSuggested(itemName) {

            this.filterSearch = itemName

            this.menu();
            this.filterMenu(itemName)

        },

        /**
        * Evento cancelar buscar ítems del menú.
        */
        onHandleCancelSearch() {

            this.filterSearch = null;
            this.menu();

        },

        /**
        * Filtrar ítems del menú por la propiedad Nombre.
        *
        * @param items
        * @param searchTerm
        */
        filterByName(items, searchTerm, itemDadName = '') {
            const normalizeText = (text) =>
                text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

            const normalizedSearchTerm = normalizeText(searchTerm);

            return items
                .map(item => {

                    const normalizedItemName = normalizeText(`${itemDadName} ${item.name}`);
                    const hasMatchingChildren = item.children
                        ? this.filterByName(item.children, searchTerm, item.name)
                        : [];

                    const isMatch = normalizedItemName.includes(normalizedSearchTerm);

                    if (isMatch || hasMatchingChildren.length > 0) {
                        return {
                            ...item,
                            children: hasMatchingChildren.length > 0 ? hasMatchingChildren : undefined
                        };
                    }

                    return null;
                })
                .filter(Boolean);
        },

        /**
        * Validar los ítems dle menú, control y permisos.
        *
        * @param menuItems
        */
        validMenuWithPermissions(menuItems) {
            this.acls = getAcls();

            const navItems = [];
            const items = menuItems ? menuItems : nav.items;

            items.forEach((item) => {

                let item_menu = JSON.parse(JSON.stringify(item));

                if (item_menu.url && item_menu.url.includes('/my-company')) {
                    let my_company = this.my_company || localStorage.getItem('my_company');
                    item_menu.url = item_menu.url.replace(':id', my_company);
                }

                let visible = this.validarPermiso(item);

                if (item.children) {
                    item_menu.children = [];
                    item.children.forEach((sub_item) => {
                        if (this.validarPermiso(sub_item)) {
                            visible = true
                            item_menu.children.push(sub_item);
                        }
                    });
                }

                if (visible || (!!item_menu.children && !!item_menu.children.length)) navItems.push(item_menu);
            });

          /*   this.overlayMenu = false */

            this.addRefEventToItemMenu();

            return navItems;

        },

        /**
        * Evento Clic a los Ítems del Menú.
        * @param event
        */
        handleSidebarNavItemClick(event) {

            // Si el elemento tiene la clase "nav-dropdown-toggle", no hacemos nada ya que es un menu con items
            if (event.target.classList.contains('nav-dropdown-toggle')) return;

            if (this.$refs.mainContainerRef) this.$refs.mainContainerRef.classList.remove('sidebar-show');

            setTimeout(() => this.onHandleCancelSearch(), 600);

        },

    },

    computed: {
        ...mapState("control_panel", ['fullscreenActive']),
        ...mapState("autenticacion", ['statusResponse']),
        ...mapState('empresa', ['selectedImagenCurrentCompany', 'selectedImagen']),

        name() {
            return this.$router.apps[0]._route.meta.title;
        },
        list() {
            return this.$router.apps[0]._route.matched.filter(
                (route) => route.meta.title || route.meta.breadcrumb
            );
        },
        ...mapState('dashboard', ['loading', 'controlAccesos', 'notifications', 'load']),
        ...mapState('autenticacion', ['ingreso', 'my_company']),

        getMenuExample() {
            const items = this.validMenuWithPermissions();
            this.overlayMenu = false
            return typeof items === 'object' ? items.splice(1, 8) : [];
        },

        getUser() {
            let userName = {
                name: "Bienvenido",
                username: "",
                email: '---',
                roles: []
            };
            
            try {

                if (this.acls && typeof this.acls === 'object' && 'user' in this.acls) {
                    userName = {
                        name: this.acls.user,
                        username: this.acls.user && this.acls.user.split(' ').map(x => x.slice(0, 1).toUpperCase()).join(''),
                        email: localStorage.getItem('email'),
                        roles: this.acls.roles
                    }
                } 

                return userName

            } catch (error) {
                return userName
            }
        }

    },

    beforeDestroy() {

        this.addRefEventToItemMenu(false);

        window.removeEventListener("mousemove", this.resetTimer);
        window.removeEventListener("keypress", this.resetTimer);
        window.removeEventListener("click", this.resetTimer);
        window.removeEventListener("scroll", this.resetTimer);
        clearInterval(this.activityTimer);
        this.from = null
    },

    updated() {
        const showMenu = this.$route.path === '/panel-de-control' ? false : true;
        if (this.$refs.sidebarToggler) {
            this.$refs.sidebarToggler.toggle(showMenu)
        }
    }

};
</script>

<style>

.ml-roles {
    margin-left: 30pt;
    margin-bottom: 0;
}

.company-content-navbar button {
    background-color: white;
    height: 2.7rem;
    padding: 1pt;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ffffff;
    cursor: normal;
    border-radius: 6pt;
}

.company-content-navbar button {
    padding: 0pt;
}

.company-content-navbar button img {
    height: 100%;
    object-fit: cover;
    border-radius: 6pt;
}

.user-content-navbar a {
    background-color: transparent;
    width: 2.5rem;
    height: 2.5rem;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px solid #20a8d8;;
    border-radius: 50%;
}

.user-content-navbar:hover {
    cursor: pointer;
}

.custom-class-user-content-navbar {
    width: fit-content;
    min-width: 254pt;
    box-shadow: var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31));
}

.custom-class-user-content-navbar :first-child {
    right: 0;
}

.custom-class-user-content-navbar--header-img span {
    width: 2.5rem;
}

.custom-class-user-content-navbar-roles {
    display: block !important;
    width: 100%;
    padding: 20pt 0;
    border-bottom: 1px solid #e1e3e1;
    margin: 5pt 0;
}

.custom-class-user-content-navbar-separator {
    border-bottom: 1px solid #e1e3e1;
    width: 100%;
    padding-bottom: 10pt;
}

.custom-class-user-content-navbar-items {
    padding: 8pt;
    width: 100%;
    border-radius: 4pt;
}

.custom-class-user-content-navbar-items:hover {
    cursor: pointer;
    background: #f0f0f0;
}

.custom-class-user-content-navbar a,
.custom-class-user-content-navbar-items a {
    text-decoration: none !important;
}

.container-fluid {
    padding: 20px !important;
}

.main-content {
    background-color: white !important;
}

.text-version {
    background: #f0f3f5;
    color: #0f0f0f;
    padding: .1em 1em;
    border: 2px solid #fff;
    margin-bottom: 0px;
}

.main-content-cp {
    background-color: #e4e5e6 !important;
}

/* Estilos buscador */

.filter-search-container {
    padding: 0.3rem;
    width: 100%;
}

.filter-search-form {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.filter-search-form-input {
    border: 1px solid #e1e3e1;
    border-radius: 5px;
    padding: 7px 2rem;
    width: 100%;
    outline: none;
}

.filter-search-form-icon {
    position: absolute;
    left: 0.40rem;
    top: 0.60rem;
    color: #058580;
    font-size: 1.3rem;
}

.filter-search-form-icon-cancel {
    position: absolute;
    right: 0.40rem;
    top: 0.65rem;
    color: #636565;
    font-size: 1.1rem;
}

.filter-search-form-icon-cancel:hover {
    cursor: pointer;
    opacity: 0.8;
}

.inicio-gradient {
    background: linear-gradient(135deg, #E0E4E6FF, #E0F2F8FF);
    background-size: cover;
}


.inicio-gradient-2 {
    background-color: transparent !important;
}
</style>
